// extracted by mini-css-extract-plugin
module.exports = {"checkoutBtn":"CheckoutButton_checkoutBtn__vL5Tn"};